  import axios from 'axios';
  import { Url } from './Path';

  export const connect = axios.create({
    baseURL: Url,
    headers: {
      'Mobile-App-api-token': 'So5gUf6ZbUHQU9SsP2j1Usx0PUCKA9gJJM2Kkgz7Fic0toLYTK14F2LKh4VXMBHR0sMKM0Y4WI7v71B8He5YdvM1YxsfKBJr6SXcJVUPrUC2owuerc61s3t29sETpzHKYvafTrk9JPs0x185ApQkr-pSLJsa3w60HlV7DF5gRLujCt6oCFET08fFu',
    }
  });
